const DEBUG =
  typeof location !== 'undefined' &&
  (new URLSearchParams(location.search).has('debug') ||
    (typeof localStorage !== 'undefined' && localStorage.getItem('cr.debug') === '1'));

export type LogTag =
  | 'engine'
  | 'worker'
  | 'worker-dbg'
  | 'paint'
  | 'gpu'
  | 'render'
  | 'doc'
  | 'palette'
  | 'export'
  | 'server'
  | 'ws'
  | 'boot';

function stamp(): string {
  if (typeof performance === 'undefined') return new Date().toISOString();
  const monotonicMs = performance.now();
  const wallTime = new Date(performance.timeOrigin + monotonicMs).toISOString();
  return `${wallTime} +${monotonicMs.toFixed(1)} ms`;
}

export const log = {
  error(tag: LogTag, msg: string, ...rest: unknown[]): void {
    console.error(`[${stamp()}] [${tag}]`, msg, ...rest);
  },
  warn(tag: LogTag, msg: string, ...rest: unknown[]): void {
    console.warn(`[${stamp()}] [${tag}]`, msg, ...rest);
  },
  info(tag: LogTag, msg: string, ...rest: unknown[]): void {
    console.info(`[${stamp()}] [${tag}]`, msg, ...rest);
  },
  debug(tag: LogTag, msg: string, ...rest: unknown[]): void {
    if (DEBUG) console.debug(`[${stamp()}] [${tag}]`, msg, ...rest);
  },
};
